<div class="performance-tiles-container" [ngClass]="rootClassName">
  <div class="performance-row">
  @for (stat of stats; track $index; let isLast=$last) {
    <div class="performance-col"
      [ngStyle]="{'color':stat.color, 'background-color':stat.background}"
      [ngClass]="{'clickable': stat.name!=='completed'}"
      (click)="onSelect(stat)"
    >
      <div class="performance-col-label">
        <span class="performance-label labelboldlarge">
          <span>{{stat.name|titlecase}}</span>
        </span>
      </div>
        <div class="performance-value">
          @if (['retention','completed'].includes(stat.name)) {
            @if (shouldShow(stat.value)) {
              <span class="performance-value-text" [ngClass]="headingClassName">{{stat.value}}</span>
              <span class="performance-text" [ngClass]="headingClassName">%</span>
            } @else {
              <span class="performance-text" [ngClass]="headingClassName">-</span>
            }
          }
          @if (stat.name === 'correct') {
            @if (shouldShow(stat.value)) {
              <span class="performance-value-text" [ngClass]="headingClassName">{{stat.value}}</span>
              <span class="performance-ratio-text" [ngClass]="headingClassName">/{{stat.count}}</span>
            } @else {
              <span class="performance-text" [ngClass]="headingClassName">-</span>
            }
          }
          @if (stat.name === 'studied') {
            @if (shouldShow(stat.value)) {
              <span class="performance-value-text" [ngClass]="headingClassName">{{stat.value}}</span>
            } @else {
              <span class="performance-text" [ngClass]="headingClassName">-</span>
            }
          }
        </div>
    </div>
  }
  </div>
  <div class="performance-heading-container">
    <div class="frame24pxspacer"></div>
    <div class="performance-heading-col">
      <div class="performance-heading-row">
        <span class="performance-heading-text headingboldsmall">
          <span>{{title}}</span>
        </span>
      </div>
    </div>
    <div class="frame8pxspacer"></div>
  </div>
</div>
